import { useEffect, useState } from 'react';
import { Card, Row, Col, Statistic, Typography, Spin, Table, Tag } from 'antd';
import {
  UserOutlined, ShopOutlined, AppstoreOutlined, ShoppingCartOutlined,
  DollarOutlined, FileTextOutlined, HeartOutlined
} from '@ant-design/icons';
import api from '../../api/axios';

const { Title } = Typography;

const fmt = (v) => Number(v || 0).toLocaleString('uz-UZ');

export default function GovDashboard() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/admingov/stats/overview')
      .then(r => setData(r.data.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div style={{ textAlign: 'center', padding: 80 }}><Spin size="large" /></div>;
  if (!data) return <div style={{ textAlign: 'center', padding: 80 }}>Ma'lumot yuklanmadi</div>;

  const cards = [
    { title: 'Foydalanuvchilar', value: data.totalUsers, icon: <UserOutlined />, color: '#1890ff' },
    { title: 'Bizneslar', value: data.totalBusiness, icon: <ShopOutlined />, color: '#52c41a' },
    { title: 'Xizmatlar', value: data.totalServices, icon: <AppstoreOutlined />, color: '#722ed1' },
    { title: 'Buyurtmalar', value: data.totalOrders, icon: <ShoppingCartOutlined />, color: '#fa8c16' },
    { title: "Umumiy daromad", value: fmt(data.totalRevenue) + " so'm", icon: <DollarOutlined />, color: '#13c2c2' },
    { title: 'Shikoyatlar', value: data.totalReports, icon: <FileTextOutlined />, color: '#f5222d' },
    { title: "To'y rejalari", value: data.totalWeddings, icon: <HeartOutlined />, color: '#eb2f96' },
  ];

  const statusColors = { pending: 'orange', confirmed: 'blue', in_progress: 'cyan', completed: 'green', cancelled: 'red' };

  return (
    <div>
      <Title level={3} style={{ marginBottom: 24 }}>Boshqaruv paneli — Umumiy statistika</Title>

      <Row gutter={[16, 16]}>
        {cards.map((c, i) => (
          <Col xs={24} sm={12} md={8} lg={6} key={i}>
            <Card hoverable style={{ borderRadius: 12 }}>
              <Statistic
                title={c.title}
                value={c.value}
                prefix={<span style={{ color: c.color }}>{c.icon}</span>}
              />
            </Card>
          </Col>
        ))}
      </Row>

      <Row gutter={[16, 16]} style={{ marginTop: 24 }}>
        <Col xs={24} lg={12}>
          <Card title="Oylik buyurtmalar trendi" style={{ borderRadius: 12 }}>
            <Table
              dataSource={data.monthlyOrders}
              rowKey="month"
              pagination={false}
              size="small"
              columns={[
                { title: 'Oy', dataIndex: 'month' },
                { title: 'Soni', dataIndex: 'count' },
                { title: 'Daromad', dataIndex: 'revenue', render: v => fmt(v) + " so'm" },
              ]}
            />
          </Card>
        </Col>
        <Col xs={24} lg={12}>
          <Card title="Viloyat bo'yicha xizmatlar" style={{ borderRadius: 12 }}>
            <Table
              dataSource={data.regionStats}
              rowKey="region"
              pagination={false}
              size="small"
              columns={[
                { title: 'Viloyat', dataIndex: 'region' },
                { title: 'Xizmatlar soni', dataIndex: 'services_count' },
              ]}
            />
          </Card>
        </Col>
      </Row>

      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24} lg={12}>
          <Card title="Xizmat turlari" style={{ borderRadius: 12 }}>
            <Table
              dataSource={data.serviceTypeStats}
              rowKey="type_name"
              pagination={false}
              size="small"
              columns={[
                { title: 'Turi', dataIndex: 'type_name' },
                { title: 'Soni', dataIndex: 'count' },
              ]}
            />
          </Card>
        </Col>
        <Col xs={24} lg={12}>
          <Card title="Buyurtma statuslari" style={{ borderRadius: 12 }}>
            <Table
              dataSource={data.orderStatusStats}
              rowKey="status"
              pagination={false}
              size="small"
              columns={[
                { title: 'Status', dataIndex: 'status', render: s => <Tag color={statusColors[s] || 'default'}>{s}</Tag> },
                { title: 'Soni', dataIndex: 'count' },
              ]}
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
}
